module.exports = __webpack_public_path__ + "img/Frame 5116.6cc3616c.jpg";